import { 
  Component,
  ChangeDetectorRef
}  from '@angular/core';

import * as Immutable from 'immutable';

import * as moment_ from 'moment';
const moment: any = (<any>moment_).default || moment_;
import * as _ from 'lodash';

import * as d3 from '../../../../source/bundles/d3-bundle';
import { TimeSeries, TimeSeriesItem } from 'source/app/objects/time-series/time-series';
import { Margin } from 'source/app/objects/margin';

@Component({
  templateUrl: './graph.html'  
})
export class GraphComponent { 
    AccountTimeSeries: any; // AccountTimeSeriesInfo;
    LinId: string; 
    StartDate = new Date();
    EndDate = undefined;

    interpolationMethod: d3.CurveFactory = d3.curveStepAfter;

    xDomain = [new Date(2017, 9), new Date(2017, 11)];
    xExtent = [new Date(2017, 9), new Date(2017, 11)];
    yDomain :any;//= [0, 10];

    Margin: Margin = { top: 0, right: 70, bottom: 90, left: 70 };
    ChartData: Immutable.List<TimeSeries>;
    PointData: Immutable.List<TimeSeries>;
    TooltipItem: {
      "datePos": Date;
      "values": Immutable.Iterable<number, {
        "seriesName": string;
        "value": TimeSeriesItem;
      }>
    };
    TooltipDateRange: string;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit() {
      this.AccountTimeSeries ={
  "GroupedBy": 0,
  "AccountId": "e2f03480-7a2a-484b-9747-f9727704d4ef",
  "LinIdsByNiinId": {},
  "Data": [],
  "PbLinAuthorizations": {},
  "OnHandDict": {},
  "AvailableDict": {},
  "DueInDict": {},
  "DueOutDict": {},
  "EohDict": {},
  "EtlDate": "2017-10-15T04:00:00.000Z"
};
      this.LinId = "bbc0150b-9fa0-46ce-9c3b-6bd1d7962848";
      if (this.AccountTimeSeries === undefined || this.LinId === undefined || this.LinId == "") return;

        if (!this.StartDate)
          this.StartDate = moment().subtract(7, 'days').toDate();

        if (!this.EndDate || this.EndDate < this.StartDate)
          this.EndDate = moment(this.StartDate).add(3, 'months').toDate();

        this.xDomain = [this.StartDate, this.EndDate];
        this.xExtent = [this.StartDate, moment(this.StartDate).add(3, 'years').toDate()];
        var updatedArray = [new TimeSeriesItem(new Date(2017, 9), 0)];
        updatedArray.push.apply(updatedArray, _.map(this.AccountTimeSeries.OnHandDict[this.LinId].Data, (d: any) => new TimeSeriesItem(new Date(d.Date), d.Value)));

        updatedArray.push(new TimeSeriesItem(new Date(2099, 12), updatedArray[updatedArray.length - 1].Value));
        var onHand = TimeSeries.fromArray(updatedArray);
        onHand.name = "On Hand";

        updatedArray = [new TimeSeriesItem(new Date(2017, 9), 0)];
        updatedArray.push.apply(updatedArray, _.map(this.AccountTimeSeries.AvailableDict[this.LinId].Data, (d: any) => new TimeSeriesItem(new Date(d.Date), d.Value)));

        updatedArray.push(new TimeSeriesItem(new Date(2017, 11), 8))
        updatedArray.push(new TimeSeriesItem(new Date(2018, 1), 0))
        updatedArray.push(new TimeSeriesItem(new Date(2099, 12), updatedArray[updatedArray.length - 1].Value));        
        var availability = TimeSeries.fromArray(updatedArray);
        availability.name = "Available";

        this.PointData = this.getPointData();
        var maxValue = _([onHand.Data, availability.Data]).concat(_.map(this.PointData.toArray(), function (d) { return d.Data })).flatten().map((d: TimeSeriesItem) => d.Value).max();

        this.yDomain = [0, Math.max(maxValue * 1.1, 10)];

        this.ChartData = Immutable.List<TimeSeries>([onHand, availability]);
    }

    ngOnChanges(changeDetection: any) {

    }

    getPointData() {
      var dueOut = TimeSeries.fromArray(_(this.AccountTimeSeries.DueOutDict[this.LinId].Data).map(d => new TimeSeriesItem(new Date(d.Date), -1 * d.Value)).value())
      dueOut.name = "Due Out";
      var dueIn = TimeSeries.fromArray(_.map(this.AccountTimeSeries.DueInDict[this.LinId].Data, (d: any) => new TimeSeriesItem(new Date(d.Date), d.Value)));
      dueIn.name = "Due In";
      return Immutable.List<TimeSeries>([dueIn, dueOut]);

      // var dueIns = TimeSeries.fromArray([
      //   new TimeSeriesItem(moment().add(2,'days').startOf('day').toDate(),5),
      //   new TimeSeriesItem(moment().add(20, 'days').startOf('day').toDate(), 12),
      //   new TimeSeriesItem(moment().add(8, 'days').startOf('day').toDate(), 2)
      // ] );
      // dueIns.name = "Due In";
      
      // var dueOuts = TimeSeries.fromArray([
      //   new TimeSeriesItem(moment().add(5, 'days').startOf('day').toDate(), 12),
      //   new TimeSeriesItem(moment().add(10, 'days').startOf('day').toDate(), 8),
      //   new TimeSeriesItem(moment().add(15, 'days').startOf('day').toDate(), 1)
      // ]);      
      // dueOuts.name = "Due Out";

      // return Immutable.List<TimeSeries>([dueIns, dueOuts]);
    }

    lineDisplay(dataPoint: [TimeSeriesItem, string]) {
      var date = dataPoint[0].Date.toISOString().substring(0, 10);

      return "<span style='font-weight: bold'>" + date + "</span><br>" +
        "<span style='font-weight: bold'>" + dataPoint[1] + "</span><br>" +
        dataPoint[0].Value;
    }

    executionCountFilter(d: TimeSeries) {
      return d.name == "Execution Count";
    }

    linesDisplay(dataPoint: {
      "datePos": Date;
      "values": Immutable.Iterable<number, {
        "seriesName": string;
        "value": TimeSeriesItem;
      }>
    }) {
      var htmlStr = "<span style='font-weight: bold'>" + dataPoint.datePos.toISOString().substring(0, 10) + "</span><br>";
      dataPoint.values.forEach(val => {
        htmlStr += "<span style='font-weight: bold'>" + val.seriesName + "</span>: " + val.value.Value + "  <br>";
      })

      return htmlStr;
    }

    tooltipItemChanged(tooltipItem: {
      "datePos": Date;
      "values": Immutable.Iterable<number, {
        "seriesName": string;
        "value": TimeSeriesItem;
      }>
    }) {
      this.TooltipItem = tooltipItem;
      this.TooltipDateRange = moment(tooltipItem.datePos).startOf('day').utc().format("DD-MMM-YYYY"); //+ " to " 
      this.changeDetectorRef.detectChanges();
      // tooltipItem.values.first().value.endDate.toISOString();
    }
} 


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/graph/graph-component.ts